import api from '../api';

export default {
  async getSponsors(filters = {}) {
    const params = {};
    if (filters && typeof filters === 'object') {
      if (filters.name) params.name = filters.name;
      if (filters.status) params.status = filters.status;
      if (filters.onboardFrom) params.onboardFrom = filters.onboardFrom;
      if (filters.onboardTo) params.onboardTo = filters.onboardTo;
    }
    const response = await api.get('/sponsors', { params });
    return response.data;
  },

  async getCampaignEvents(query = '', limit = 20) {
    const response = await api.get('/campaigns/events', {
      params: {
        q: query,
        limit,
      },
    });
    return response.data;
  },

  async createSponsor(payload) {
    const response = await api.post('/sponsors', payload);
    return response.data;
  },

  async updateSponsor(sponsorId, payload) {
    const response = await api.put(`/sponsors/${sponsorId}`, payload);
    return response.data;
  },

  async deleteSponsor(sponsorId) {
    const response = await api.delete(`/sponsors/${sponsorId}`);
    return response.data;
  },

  async getCampaigns(sponsorId) {
    const response = await api.get(`/sponsors/${sponsorId}/campaigns`);
    return response.data;
  },

  async createCampaign(sponsorId, payload) {
    const response = await api.post(`/sponsors/${sponsorId}/campaigns`, payload);
    return response.data;
  },

  async updateCampaign(campaignId, payload) {
    const response = await api.put(`/campaigns/${campaignId}`, payload);
    return response.data;
  },

  async deleteCampaign(campaignId) {
    const response = await api.delete(`/campaigns/${campaignId}`);
    return response.data;
  },

  async uploadCampaignFiles(campaignId, label, files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    const response = await api.post(`/campaigns/${campaignId}/files/${label}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async getDcmNotifications(params = {}) {
    const response = await api.get('/dcm/notifications', { params });
    return response.data;
  },

  async markDcmNotificationRead(notificationId) {
    const response = await api.put(`/dcm/notifications/${notificationId}/read`);
    return response.data;
  },

  async getDcmCampaignDetails(campaignId) {
    const response = await api.get(`/dcm/campaigns/${campaignId}`);
    return response.data;
  },

  async acceptDcmCampaignTask(campaignId) {
    const response = await api.put(`/dcm/campaigns/${campaignId}/accept`);
    return response.data;
  },

  async getCreativeUsers() {
    const response = await api.get('/dcm/creative-users');
    return response.data;
  },

  async assignCampaignToCreative(payload) {
    const response = await api.post('/dcm/creative-assignments', payload);
    return response.data;
  },

  async getCreativeAssignments() {
    const response = await api.get('/creative/assignments');
    return response.data;
  },

  async markCreativeAssignmentRead(assignmentId) {
    const response = await api.put(`/creative/assignments/${assignmentId}/read`);
    return response.data;
  },

  async getDcmOperations() {
    const response = await api.get('/dcm/operations');
    return response.data;
  },

  async updateAssignmentStatus(assignmentId, status, extraPayload = {}) {
    const response = await api.put(`/creative/assignments/${assignmentId}/status`, {
      status,
      ...(extraPayload || {}),
    });
    return response.data;
  },

  async getCreativeNotifications() {
    const response = await api.get('/creative/notifications');
    return response.data;
  },

  async markCreativeNotificationRead(notificationId) {
    const response = await api.put(`/creative/notifications/${notificationId}/read`);
    return response.data;
  },

  async uploadCreativeDeliverables(assignmentId, files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    const response = await api.post(`/creative/assignments/${assignmentId}/deliverables`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async getCampaignDashboardData() {
    const response = await api.get('/campaign-dashboard');
    return response.data;
  },

  async createCampaignChannelUpload(campaignId, payload) {
    const response = await api.post(`/campaigns/${campaignId}/channel-uploads`, payload);
    return response.data;
  },

  async createDirectUpload(payload) {
    const response = await api.post('/direct-uploads', payload);
    return response.data;
  },

  async listDirectUploads(filters = {}) {
    const params = {};
    if (filters.createdBy) params.createdBy = filters.createdBy;
    if (filters.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters.dateTo) params.dateTo = filters.dateTo;
    if (filters.limit) params.limit = filters.limit;
    const response = await api.get('/direct-uploads', { params });
    return response.data;
  },

  async getDirectUploadStats(filters = {}) {
    const params = {};
    if (filters.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters.dateTo) params.dateTo = filters.dateTo;
    const response = await api.get('/direct-uploads/stats', { params });
    return response.data;
  },

  async getReportSettings() {
    const response = await api.get('/report-settings');
    return response.data;
  },

  async updateReportSettings(payload) {
    const response = await api.put('/report-settings', payload || {});
    return response.data;
  },

  async createSponsorReportShareLink(sponsorId, campaignId = '') {
    const body = campaignId ? { campaignId } : {};
    const response = await api.post(`/sponsors/${sponsorId}/report-share-link`, body);
    return response.data;
  },

  async listSponsorReportShareLinks(sponsorId) {
    const response = await api.get(`/sponsors/${sponsorId}/report-share-links`);
    return response.data;
  },

  async revokeSponsorReportShareLink(sponsorId, shareId) {
    const response = await api.delete(`/sponsors/${sponsorId}/report-share-links/${shareId}`);
    return response.data;
  },

  async getPublicSponsorReport(token, filters = {}) {
    const params = {};
    if (filters.campaignId) params.campaignId = filters.campaignId;
    if (filters.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters.dateTo) params.dateTo = filters.dateTo;
    const response = await api.get(`/public/sponsor-report/${token}`, { params, timeout: 60000 });
    return response.data;
  },
};
